import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './core/components/login/login.component';
import {CoreModule} from './core/core.module';


const routes: Routes = [
    {
        path: '',
        redirectTo: 'admin',
        pathMatch: 'full'
    },
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
    },
    {
        path: '**',
        redirectTo: 'admin',
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes), CoreModule],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
